"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRange = void 0;
var react_1 = require("@headlessui/react");
var moment_1 = __importDefault(require("moment"));
var react_2 = __importStar(require("react"));
var button_1 = require("../action/button");
var textButton_1 = require("../action/textButton");
var modal_1 = require("../display/modal");
var datePicker_1 = require("../input/datePicker");
var toggle_1 = require("../action/toggle");
var select_1 = require("../input/select");
var startDate = (0, moment_1.default)().toDate();
startDate.setDate((0, moment_1.default)().toDate().getDate() - 7);
var defaultInput = {
    startDate: startDate,
    endDate: (0, moment_1.default)().toDate(),
    startTime: "00:00:00",
    endTime: "23:59:59",
    isDuration: true,
};
var DateRange = /** @class */ (function (_super) {
    __extends(DateRange, _super);
    function DateRange() {
        var _this = this;
        var _a;
        _this = _super.apply(this, arguments) || this;
        _this.state = {
            customDate: (_a = _this.props.customDate) !== null && _a !== void 0 ? _a : defaultInput,
            tempDate: defaultInput,
            dateRangeModalVisible: false,
            rangeError: {
                dateError: "",
                timeError: "",
            },
        };
        _this.handleClonedDateObj = function (dateObj, id, value) {
            var _a;
            var clonedDateObj = JSON.parse(JSON.stringify(dateObj));
            clonedDateObj["startDate"] = dateObj.startDate;
            clonedDateObj["endDate"] = dateObj.endDate;
            clonedDateObj["isDuration"] = dateObj.isDuration;
            clonedDateObj["startTime"] = dateObj.startTime;
            clonedDateObj["endTime"] = dateObj.endTime;
            return __assign(__assign({}, clonedDateObj), (_a = {}, _a[id] = value, _a));
        };
        _this.handleOnChangeDateTime = function (id, value) {
            var dateObj = _this.handleClonedDateObj(_this.state.tempDate, id, value);
            _this.setState({
                tempDate: dateObj,
            });
        };
        _this.handleOnChangeDateRangeType = function () {
            var dateObj = _this.handleClonedDateObj(_this.state.tempDate, "isDuration", !_this.state.tempDate.isDuration);
            _this.setState({
                tempDate: dateObj,
            });
        };
        _this.handleDateRangeModalVisible = function (visible) {
            _this.setState({
                dateRangeModalVisible: visible,
            });
        };
        _this.handleSetSuggestedDate = function (type) {
            var todayDate = (0, moment_1.default)().toDate();
            var startDate = (0, moment_1.default)().toDate();
            switch (type) {
                case "seven":
                    startDate.setDate(todayDate.getDate() - 7);
                    break;
                case "28days":
                    startDate.setDate(todayDate.getDate() - 28);
                    break;
                default:
                    break;
            }
            _this.setState({
                tempDate: {
                    startDate: startDate,
                    endDate: todayDate,
                    isDuration: true,
                },
            });
        };
        _this.handleValidateDateRange = function () {
            var valid = false;
            var timeCondition = (0, moment_1.default)(_this.state.tempDate.startDate).isSame(_this.state.tempDate.endDate, "date")
                ? _this.state.tempDate.startTime &&
                    _this.state.tempDate.endTime &&
                    (0, moment_1.default)((0, moment_1.default)(_this.state.tempDate.startTime, "HH:mm:ss")).isBefore((0, moment_1.default)(_this.state.tempDate.endTime, "HH:mm:ss"))
                : true;
            if (timeCondition &&
                _this.state.tempDate.startDate &&
                _this.state.tempDate.endDate &&
                (0, moment_1.default)(_this.state.tempDate.startDate).isSameOrBefore(_this.state.tempDate.endDate, "date")) {
                valid = true;
            }
            else {
                var clonedRangeError = JSON.parse(JSON.stringify(_this.state.rangeError));
                if (!timeCondition)
                    clonedRangeError["timeError"] = "Please select a proper time range";
                else
                    clonedRangeError["dateError"] = "Please select a proper date range";
                _this.setState({
                    rangeError: clonedRangeError,
                });
            }
            return valid;
        };
        _this.handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
            var validate;
            var _this = this;
            return __generator(this, function (_a) {
                validate = this.handleValidateDateRange();
                if (validate) {
                    this.setState({
                        customDate: this.state.tempDate,
                    }, function () {
                        _this.handleDateRangeModalVisible(false);
                        if (_this.props.onChangeDate) {
                            _this.props.onChangeDate(_this.state.customDate);
                        }
                    });
                }
                return [2 /*return*/];
            });
        }); };
        _this.renderTimeOption = function (isStart) {
            var timeIntervals = [];
            for (var hours = 0; hours < 24; hours++) {
                var hourStr = hours.toString().padStart(2, "0");
                var minuesStr = isStart
                    ? "0".toString().padStart(2, "0")
                    : "59".toString().padStart(2, "0");
                timeIntervals.push({
                    key: "".concat(hourStr, ":").concat(minuesStr, ":").concat(minuesStr),
                    label: "".concat(hourStr, ":").concat(minuesStr),
                });
            }
            return timeIntervals;
        };
        _this.renderDateModalContent = function () {
            var _a, _b;
            return (react_2.default.createElement("div", { className: "px-3 mt-5 sm:px-0 space-y-5" },
                _this.state.tempDate.isDuration ? (react_2.default.createElement(datePicker_1.InputDatePicker, { id: "startDate", range: true, startDate: _this.state.tempDate.startDate, endDate: _this.state.tempDate.endDate, onChange: function (id, date, type) {
                        if (type === "start") {
                            _this.handleOnChangeDateTime(id, date);
                        }
                        else {
                            _this.handleOnChangeDateTime("endDate", date);
                        }
                    } })) : (react_2.default.createElement(datePicker_1.InputDatePicker, { id: "endDate", title: "Until", value: _this.state.tempDate.endDate, onChange: function (id, date) {
                        _this.handleOnChangeDateTime(id, date);
                    } })),
                react_2.default.createElement("span", { className: "text-red-500 text-sm mt-2" }, _this.state.rangeError.dateError),
                (0, moment_1.default)(_this.state.tempDate.startDate).isSame(_this.state.tempDate.endDate, "date") &&
                    _this.state.tempDate.isDuration && (react_2.default.createElement("div", { className: "grid grid-cols-2" },
                    react_2.default.createElement("div", { className: "mr-2" },
                        react_2.default.createElement(select_1.Select, { label: "Start Time", options: _this.renderTimeOption(true), value: (_a = _this.state.tempDate.startTime) !== null && _a !== void 0 ? _a : "", onChange: function (value) {
                                _this.handleOnChangeDateTime("startTime", value);
                            } })),
                    react_2.default.createElement("div", { className: "ml-2" },
                        react_2.default.createElement(select_1.Select, { label: "End Time", options: _this.renderTimeOption(false), value: (_b = _this.state.tempDate.endTime) !== null && _b !== void 0 ? _b : "", onChange: function (value) {
                                _this.handleOnChangeDateTime("endTime", value);
                            } })),
                    react_2.default.createElement("span", { className: "text-red-500 text-sm mt-2" }, _this.state.rangeError.timeError))),
                react_2.default.createElement(toggle_1.Toggle, { direction: "right", text: "With Start Date", value: _this.state.tempDate.isDuration, onClick: function () {
                        _this.handleOnChangeDateRangeType();
                    } }),
                react_2.default.createElement("div", { className: "flex flex-col sm:flex-row w-full mt-5" },
                    react_2.default.createElement("p", { className: "mb-3" }, "Suggested Duration: "),
                    react_2.default.createElement("div", { className: "w-full mt-2 sm:w-56 sm:mt-0" },
                        react_2.default.createElement(textButton_1.TextButton, { className: "ml-3 mb-3", text: "Last 7 days", onClick: function () {
                                _this.handleSetSuggestedDate("seven");
                            } }),
                        react_2.default.createElement(textButton_1.TextButton, { className: "ml-3 mb-3", text: "Last 28 days", onClick: function () {
                                _this.handleSetSuggestedDate("28days");
                            } }))),
                react_2.default.createElement("div", { className: "flex flex-row mt-6 pt-32 justify-end" },
                    react_2.default.createElement(button_1.Button, { text: "Close", size: "small", type: "light", onClick: function () {
                            _this.handleDateRangeModalVisible(false);
                        } }),
                    react_2.default.createElement(button_1.Button, { className: "ml-4", text: "Submit", size: "small", type: "normal", onClick: function () {
                            _this.handleSubmit();
                        } }))));
        };
        return _this;
    }
    DateRange.prototype.render = function () {
        var _this = this;
        var _a, _b;
        var defaultClassName = "flex flex-col sm:flex-row w-full items-end ";
        if (this.props.className)
            defaultClassName += this.props.className;
        return (react_2.default.createElement(react_2.default.Fragment, null,
            react_2.default.createElement(modal_1.Modal, { title: "Select Date Range", open: this.state.dateRangeModalVisible, lib: {
                    Dialog: react_1.Dialog,
                    Transition: react_1.Transition,
                }, renderContent: this.renderDateModalContent, onClose: function () {
                    _this.handleDateRangeModalVisible(false);
                } }),
            react_2.default.createElement("div", { className: defaultClassName },
                react_2.default.createElement("div", { className: "grow" }),
                react_2.default.createElement("p", { className: "ml-3 text-gray-700" }, "Custom Duration:"),
                react_2.default.createElement("div", null,
                    react_2.default.createElement(textButton_1.TextButton, { className: "ml-3", text: ((_a = this.state.customDate) === null || _a === void 0 ? void 0 : _a.isDuration)
                            ? (0, moment_1.default)(this.state.customDate.startDate).format("DD-MM-YYYY") +
                                " - " +
                                (0, moment_1.default)(this.state.customDate.endDate).format("DD-MM-YYYY")
                            : "Beginning - " +
                                (0, moment_1.default)((_b = this.state.customDate) === null || _b === void 0 ? void 0 : _b.endDate).format("DD-MM-YYYY"), onClick: function () {
                            _this.setState({
                                tempDate: _this.state.customDate,
                            }, function () {
                                _this.handleDateRangeModalVisible(true);
                            });
                        } })))));
    };
    return DateRange;
}(react_2.Component));
exports.DateRange = DateRange;
//# sourceMappingURL=DateRange.js.map